exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".removable[data-v-f9ee6404]{position:relative;flex-grow:1}.removable .removable__icon[data-v-f9ee6404]{position:absolute;right:6px;top:50%;z-index:2;width:1.4rem;height:1.4rem;padding:.4rem;color:#aaa;font-size:1.3rem;font-weight:700;text-align:center;background:#dfe2ea;border-radius:50%;cursor:pointer;transform:translateY(-50%)}.removable .removable__icon span[data-v-f9ee6404]{position:relative;top:-.1rem}", ""]);

// exports
